import 'summernote/dist/summernote-bs4.min.js'
import Swal from 'sweetalert2';

export default class AssessmentsPreferences {

  constructor() {}

  render() {

    // Set function for confirming leaving without saved changes
    const confirmLeave = function(e, href) {
      e.preventDefault();

      // Confirm and then continue with request
      return Swal.fire({
        title: "You have unsaved changes",
        text: "Are you sure you want to leave? You have unsaved changes that have not been applied.",
        animation: false,
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonText: 'Continue anyway',
        cancelButtonText: 'Cancel',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-light border',
          popup: 'animated fadeIn faster'
        }
      }).then((result) => {
        if (result.value) {
          Turbo.visit(href);
        }
      });

    }

    // If unsaved changes, confirm before leaving 
    $('a:not(#updateAssessment):not(.uc-ok)').click(function(e) {
      let uc = $('#updateAssessment').attr('data-unsaved-changes');
      let href = $(this).attr('href');
      if ( typeof uc !== 'undefined' && uc !== false && href !== '#' ) {
        confirmLeave(e, href);
      }
    });

    // Mark changes 
    $('input, select, textarea').on('change', function() {
      $('#updateAssessment').attr('data-unsaved-changes', 'true')
    })
    $('.summernote-default').on('summernote.change', function(we, contents, $editable) {
      $('#updateAssessment').attr('data-unsaved-changes', 'true')
    });

    // Reset default text
    $('.reset-default-message').click(function(e) {
      e.preventDefault();
      let message = $(this).attr('data-html');
      let input = $(this).closest('.form-group').find('.summernote-default');
      input.summernote('code', '');
      input.summernote('pasteHTML', message);
    });

    // Next step options
    $('.next-step-select').change(function(e) {
      let val = $(this).val();
      let messageDetails = $('#nextStepMessageOpt');
      let linkDetails = $('#nextStepLinkOpt');
      if (val === 'link') {
        linkDetails.removeClass('d-none').addClass('d-flex');
        messageDetails.addClass('d-none').removeClass('d-flex');
      } else {
        messageDetails.removeClass('d-none').addClass('d-flex');
        linkDetails.addClass('d-none').removeClass('d-flex');
      }
    });

  }

}